const getStorage = (isPermanent: boolean) => (isPermanent ? localStorage : sessionStorage);

export function readLocallyStored(name: string): unknown;
export function readLocallyStored<T>(name: string): T | undefined;
export function readLocallyStored<T>(name: string, defaultValue: T): T;
export function readLocallyStored<T>(name: string, defaultValue: T, isPermanent: boolean): T;

export function readLocallyStored<T>(
    name: string,
    defaultValue?: T,
    isPermanent?: boolean
): T | undefined {
    if (
        !window.localStorage ||
        !window.sessionStorage ||
        typeof localStorage !== 'object' ||
        typeof sessionStorage !== 'object'
    )
        return defaultValue;

    let raw;
    if (typeof isPermanent === 'undefined') {
        raw = getStorage(true).getItem(name) || getStorage(false).getItem(name);
    } else {
        raw = getStorage(isPermanent).getItem(name);
    }
    return raw ? JSON.parse(raw) : defaultValue;
}

export const writeLocallyStored = (
    name: string,
    val: unknown = null,
    isPermanent = false
): void => {
    const storage = getStorage(isPermanent);
    if (typeof storage === 'object' && storage && typeof storage.setItem === 'function') {
        try {
            storage.setItem(name, JSON.stringify(val));
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(
                `Failure when trying to write "${name}" key to ${
                    isPermanent ? 'local' : 'session'
                }Storage:`,
                e
            );
        }
    } else {
        // eslint-disable-next-line no-console
        console.error(`${isPermanent ? 'local' : 'session'}Storage damaged, value:`, storage);
    }
};

export const removeLocallyStored = (name: string, isPermanent = false): void => {
    writeLocallyStored(name, '', isPermanent);
};

export const eraseLocallyStored = (name: string, isPermanent = false): void => {
    const storage = getStorage(isPermanent);
    if (typeof storage === 'object' && typeof storage.setItem === 'function') {
        storage.removeItem(name);
    } else {
        // eslint-disable-next-line no-console
        console.error(`${isPermanent ? 'local' : 'session'}Storage damaged, value:`, storage);
    }
};
